<template>
  <section class="loginForm_wrapper admin wrapper soft">
    <div class="loginForm_inner">
      <div class="loginForm_header">
        <h1>{{ $store.getters["event/event"].name }}</h1>
      </div>
      <div class="loginForm_body">
        <div class="form_title inner">
          <span>ログイン</span>
        </div>
        <validation-observer ref="observer" v-slot="{handleSubmit, invalid}" class="form_body">
          <div class="inner">
            <form @submit.prevent="handleSubmit(login)">
              <div v-if="message" class="error">
                <span style="color: #ff0000;">{{ message }}</span>
              </div>

              <validation-provider rules="required" v-slot="{errors}" name="メールアドレス／社員番号" class="form-group">
                <label for="email">メールアドレス／社員番号</label>
                <input type="text" id="email" name="email" v-model="loginForm.email" />
                <ul v-if="errors.length">
                  <li v-for="(error, key) in errors" :key="key" style="color: #ff0000;">{{ error }}</li>
                </ul>
              </validation-provider>

              <validation-provider rules="required" v-slot="{errors}" name="パスワード" class="form-group">
                <label for="password">パスワード</label>
                <input type="password" id="password" name="password" v-model="loginForm.password" />
                <ul v-if="errors.length">
                  <li v-for="(error, key) in errors" :key="key" style="color: #ff0000;">{{ error }}</li>
                </ul>
              </validation-provider>

              <div class="button_area">
                <button class="btn" type="submit" :disabled="invalid">ログイン</button>
              </div>
            </form>
          </div>
        </validation-observer>
      </div>
    </div>
    <div class="loginForm_footer">
      <router-link :to="{name: 'UserLogin'}">
        <span>G-Plus会員ログイン</span>
      </router-link>
      <router-link :to="{name: 'GuestLogin'}">
        <span>招待者ログイン</span>
      </router-link>
    </div>
  </section>
</template>

<script>
export default {
  name: "LoginForAdmin",
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      loginForm: {
        email: "",
        password: ""
      }
    }
  },
  computed: {
    event() {
      return this.$store.getters["event/event"]
    },
    message() {
      return this.$store.getters["auth/message"]
    }
  },
  mounted() {
    this.$store.commit("loading/setLoading", false)
  },
  methods: {
    login: async function() {
      this.$store.commit("loading/setLoading", true)
      await this.$store.dispatch("auth/login", {
        endpoint: `auth/${this.slug}/admin/login`,
        inputs: this.loginForm,
        validationObserver: this.$refs.observer,
        slug: this.slug
      })
    }
  }
}
</script>
